import ApplicationController from "../application_controller";

export default class SyncedSlugController extends ApplicationController {
  static targets = ["slugField", "preview", "previewRow", "editRow"];

  declare readonly slugFieldTarget: HTMLInputElement;
  declare readonly previewTarget: HTMLElement;
  declare readonly hasPreviewTarget: boolean;
  declare readonly previewRowTarget: HTMLElement;
  declare readonly editRowTarget: HTMLElement;
  declare readonly hasEditRowTarget: boolean;
  sync = true;

  handleSourceChange(event: Event) {
    if (this.sync) {
      const sourceInput = event.target as HTMLInputElement;
      const slug = this.parameterize(sourceInput.value);
      this.slugFieldTarget.value = slug;
      if (this.hasPreviewTarget) {
        this.previewTarget.textContent = slug;
      }
    }
  }

  unsync() {
    this.sync = false;
  }

  reveal() {
    this.editRowTarget.removeAttribute("hidden");
    this.previewRowTarget.toggleAttribute("hidden", true);
    this.slugFieldTarget.focus();
  }

  revealOnSlugError(event: StimulusEvent) {
    if (!this.hasEditRowTarget || !this.editRowTarget.hasAttribute("hidden")) return;

    const { errorAttributes } = event.detail.data;
    if (errorAttributes.split(" ").includes("slug")) {
      this.reveal();
    }
  }

  parameterize(text: string): string {
    // JavaScript implementation that matches Rails String#parameterize behavior
    // https://api.rubyonrails.org/classes/ActiveSupport/Inflector.html#method-i-parameterize
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9-]/g, "-") // Turn non-alphanumeric characters into hyphens
      .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
      .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens
  }
}
